// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_chat__Chat_projection from "../../shared/chat/chat_projection.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_message_model from "./web_message_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)))) {
    return;
  } else {
    return "/api/workspaces/" + (match._0 + ("/sessions/" + (match._2 + "/commands")));
  }
}

function active(t, generation) {
  if (generation === t.generation) {
    return path(t) !== undefined;
  } else {
    return false;
  }
}

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  t.revision = t.revision + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  t.loading = false;
  t.dirty = false;
}

function refresh(t) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  if (t.loading) {
    t.dirty = true;
    return;
  }
  t.loading = true;
  t.dirty = false;
  const generation = t.generation;
  const revision = t.revision;
  Mapre_web__Browser.request(t.controller, undefined, undefined, path$1).then(function (result) {
    if (active(t, generation)) {
      t.loading = false;
      if (revision !== t.revision) {
        t.dirty = true;
      } else if (result.TAG === /* Ok */ 0) {
        const json = result._0;
        try {
          Curry._1(t.emit, {
            TAG: /* Commands */ 14,
            _0: Mapre_web__Web_codec.commands(json)
          });
          const match = Mapre_web__Web_message_model.decode(json);
          const before = Mapre_web__Web_message_model.resume(Curry._1(t.model, undefined).messages);
          Curry._1(t.emit, {
            TAG: /* Messages */ 43,
            _0: {
              TAG: /* Loaded */ 3,
              _0: match[0],
              _1: match[1]
            }
          });
          if (before === undefined && Mapre_web__Web_message_model.resume(Curry._1(t.model, undefined).messages) !== undefined) {
            Curry._1(t.subscriptions, undefined);
          }
          
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Messages */ 43,
              _0: {
                TAG: /* Rejected */ 8,
                _0: "Invalid conversation response."
              }
            });
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          }
          
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        }
        
      }
      if (t.dirty) {
        refresh(t);
      }
      
    }
    return Promise.resolve();
  });
}

function error(t, error$1) {
  if (/* tag */ typeof error$1 !== "object" && typeof error$1 !== "function") {
    switch (error$1) {
      case /* Unauthorized */ 0 :
        return Curry._1(t.failure, error$1);
      case /* Forbidden */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: /* Denied */ 5
        });
      case /* Invalid_response */ 2 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: /* Uncertain_delivery */ 4
        });
        return refresh(t);
    }
  } else {
    if (error$1.TAG === /* Missing */ 0) {
      if (error$1._0 !== "connection_not_found") {
        return Curry._1(t.failure, error$1);
      }
      Curry._1(t.emit, {
        TAG: /* Messages */ 43,
        _0: {
          TAG: /* Rejected */ 8,
          _0: "Selected subscription is no longer available. Refresh subscriptions and choose an account."
        }
      });
      Curry._1(t.subscriptions, undefined);
      return refresh(t);
    }
    let exit = 0;
    switch (error$1._0) {
      case "agent_image_unsupported" :
        return Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "This agent does not support image attachments. Choose a supported agent or remove the image."
          }
        });
      case "connection_authorization_changed" :
      case "connection_unavailable" :
      case "no_available_subscription" :
        exit = 2;
        break;
      case "command_id_reused" :
      case "idempotency_key_reused" :
      case "invalid_message" :
      case "invalid_resume_input" :
      case "prompt_too_large" :
        exit = 5;
        break;
      case "resume_agent_mismatch" :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "Choose a subscription for the original agent."
          }
        });
        return refresh(t);
      case "resume_cleanup_pending" :
      case "resume_retention_expired" :
      case "resume_source_unavailable" :
        exit = 3;
        break;
      case "runtime_attachments_unavailable" :
        return Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "This session's runtime does not support attachments. Start a new session with an updated environment, or send text only."
          }
        });
      case "run_not_active" :
      case "runtime_initializing" :
      case "session_resume_required" :
        exit = 4;
        break;
      case "resume_admission_conflict" :
      case "run_changed" :
      case "version_conflict" :
        exit = 1;
        break;
      default:
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: /* Uncertain_delivery */ 4
        });
        return refresh(t);
    }
    switch (exit) {
      case 1 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "The conversation changed. Review it and send again."
          }
        });
        return refresh(t);
      case 2 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "Choose an available subscription account and send again."
          }
        });
        Curry._1(t.subscriptions, undefined);
        return refresh(t);
      case 3 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "This retained session is not ready to continue. Refresh its state."
          }
        });
        return refresh(t);
      case 4 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "This session is not ready for new messages. Refresh its state."
          }
        });
        return refresh(t);
      case 5 :
        Curry._1(t.emit, {
          TAG: /* Messages */ 43,
          _0: {
            TAG: /* Rejected */ 8,
            _0: "The message was rejected. Check its text and refresh the conversation."
          }
        });
        return refresh(t);
    }
  }
}

function current_attempt(t, id) {
  return Stdlib__Option.fold(false, (function (attempt) {
    return attempt.id === id;
  }), Curry._1(t.model, undefined).messages.attempt);
}

function body(attempt) {
  const r = attempt.mode;
  let extra;
  if (/* tag */ typeof r !== "object" && typeof r !== "function") {
    extra = /* [] */ 0;
  } else {
    const r$1 = r._0;
    extra = {
      hd: [
        "connection_id",
        Mapre_wire__Json.str(r$1.connection_id)
      ],
      tl: {
        hd: [
          "expected_connection_version",
          r$1.connection_version
        ],
        tl: {
          hd: [
            "budget_microusd",
            r$1.budget_microusd
          ],
          tl: /* [] */ 0
        }
      }
    };
  }
  const match = attempt.mode;
  let tmp;
  tmp = /* tag */ typeof match !== "object" && typeof match !== "function" && match !== /* Prompt */ 0 ? ({
      hd: [
        "kind",
        Mapre_wire__Json.str("cancel")
      ],
      tl: /* [] */ 0
    }) : /* [] */ 0;
  return JSON.stringify(Js__Js_dict.fromList(Stdlib.$at({
    hd: [
      "command_id",
      Mapre_wire__Json.str(attempt.id)
    ],
    tl: {
      hd: [
        "run_id",
        Mapre_wire__Json.str(attempt.run)
      ],
      tl: {
        hd: [
          "expected_version",
          attempt.version
        ],
        tl: {
          hd: [
            "text",
            Mapre_wire__Json.str(attempt.text)
          ],
          tl: /* [] */ 0
        }
      }
    }
  }, Stdlib.$at(tmp, Stdlib.$at(Mapre_web__Web_attachments_model.fields(attempt.attachments), extra)))));
}

function obj(json) {
  const fields = Js__Js_json.decodeObject(json);
  if (fields !== undefined) {
    return Caml_option.valFromOption(fields);
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "expected_object"
    });
}

function admission(json) {
  const fields = Js__Js_json.decodeObject(json);
  if (fields !== undefined) {
    return Stdlib__Option.bind(Js__Js_dict.get(Caml_option.valFromOption(fields), "state"), Js__Js_json.decodeString);
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "expected_object"
    });
}

function receipt(t, attempt, json) {
  if (Mapre_wire__Json.string(json, "command_id") !== attempt.id) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_command_receipt"
      });
  }
  const match = attempt.mode;
  let exit = 0;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    exit = 1;
  } else {
    const run = Mapre_wire__Json.string(Mapre_wire__Json.get(json, "run"), "id");
    const session = Mapre_wire__Json.string(Mapre_wire__Json.get(json, "session"), "id");
    if (run === "" || run === attempt.run || Caml_obj.caml_notequal(session, Mapre_web__Web_types.session(Curry._1(t.model, undefined).route))) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_resume_receipt"
        });
    }
    return {
      NAME: "version",
      VAL: 0
    };
  }
  if (exit === 1) {
    const match$1 = admission(json);
    let exit$1 = 0;
    if (match$1 !== undefined) {
      if (match$1 === "resume_pending") {
        if (!Js__Js_json.test(Mapre_wire__Json.get(json, "run_id"), /* Null */ 5) || Mapre_wire__Json.string(json, "source_run_id") !== attempt.run) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "invalid_resume_pending_receipt"
            });
        }
        return "admitted";
      }
      exit$1 = 2;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      const run$1 = Js__Js_dict.get(obj(json), "run");
      let exit$2 = 0;
      if (run$1 !== undefined) {
        const run$2 = Caml_option.valFromOption(run$1);
        if (Js__Js_json.decodeObject(run$2) !== undefined) {
          const run_id = Mapre_wire__Json.string(run$2, "id");
          const session$1 = Mapre_wire__Json.string(Mapre_wire__Json.get(json, "session"), "id");
          if (run_id === "" || run_id === attempt.run || Caml_obj.caml_notequal(session$1, Mapre_web__Web_types.session(Curry._1(t.model, undefined).route))) {
            throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
                MEL_EXN_ID: Mapre_wire__Json.Invalid,
                _1: "invalid_resume_receipt"
              });
          }
          return "admitted";
        }
        exit$2 = 3;
      } else {
        exit$2 = 3;
      }
      if (exit$2 === 3) {
        const version = Mapre_wire__Json.integer(json, "version");
        if (version !== (attempt.version + 1 | 0)) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "invalid_command_receipt"
            });
        }
        return {
          NAME: "version",
          VAL: version
        };
      }
      
    }
    
  }
  
}

function send(t, attempt) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  t.revision = t.revision + 1 | 0;
  Curry._1(t.emit, {
    TAG: /* Messages */ 43,
    _0: {
      TAG: /* Started */ 4,
      _0: {
        id: attempt.id,
        run: attempt.run,
        version: attempt.version,
        text: attempt.text,
        attachments: attempt.attachments,
        phase: /* Sending */ 0,
        mode: attempt.mode
      }
    }
  });
  const generation = t.generation;
  const body$1 = body(attempt);
  const match = attempt.mode;
  let path$2;
  path$2 = /* tag */ typeof match !== "object" && typeof match !== "function" ? path$1 : Stdlib__String.sub(path$1, 0, path$1.length - 8 | 0) + "resume";
  Mapre_web__Browser.request(t.controller, undefined, body$1, path$2).then(function (result) {
    if (active(t, generation)) {
      t.revision = t.revision + 1 | 0;
      if (current_attempt(t, attempt.id)) {
        if (result.TAG === /* Ok */ 0) {
          try {
            const match = receipt(t, attempt, result._0);
            if (typeof match === "string") {
              Curry._1(t.emit, {
                TAG: /* Messages */ 43,
                _0: {
                  TAG: /* Admitted */ 6,
                  _0: attempt.id
                }
              });
              refresh(t);
            } else {
              Curry._1(t.emit, {
                TAG: /* Messages */ 43,
                _0: {
                  TAG: /* Accepted */ 5,
                  _0: attempt.id,
                  _1: match.VAL
                }
              });
              refresh(t);
            }
          }
          catch (raw_exn){
            const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
              error(t, /* Invalid_response */ 2);
            } else {
              throw exn;
            }
          }
        } else {
          error(t, result._0);
        }
      } else {
        refresh(t);
      }
    }
    return Promise.resolve();
  });
}

function dispatch(t, action) {
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Messages */ 43,
      _0: action
    });
  }
  switch (action) {
    case /* Send */ 0 :
      const model = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(model) && !Mapre_web__Web_model.locked(model) && Mapre_web__Web_message_model.ready(model.messages, model.subscriptions) && (Mapre_web__Web_message_model.resume(model.messages) === undefined || !model.subscriptions_loading)) {
        return Stdlib__Option.iter((function (control) {
          send(t, {
            id: crypto.randomUUID(),
            run: control.id,
            version: control.version,
            text: model.messages.draft,
            attachments: Mapre_web__Web_attachments_model.references(model.messages.attachments),
            phase: /* Sending */ 0,
            mode: Mapre_web__Web_message_model.mode(model.messages)
          });
        }), model.messages.control);
      } else {
        return;
      }
    case /* Stop */ 1 :
      const model$1 = Curry._1(t.model, undefined);
      if (Mapre_chat__Chat_projection.busy(model$1.commands)) {
        return Stdlib__Option.iter((function (control) {
          if (control.can_send) {
            return send(t, {
              id: crypto.randomUUID(),
              run: control.id,
              version: control.version,
              text: "",
              attachments: /* [] */ 0,
              phase: /* Sending */ 0,
              mode: /* Cancel */ 1
            });
          }
          
        }), model$1.messages.control);
      } else {
        return;
      }
    case /* Retry */ 2 :
      const model$2 = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(model$2) && !Mapre_web__Web_model.locked(model$2) && !model$2.messages.denied) {
        return Stdlib__Option.iter((function (a) {
          if (a.phase === /* Uncertain */ 1) {
            return send(t, a);
          }
          
        }), model$2.messages.attempt);
      } else {
        return;
      }
    case /* Refresh */ 3 :
      const generation = t.generation;
      if (path(t) !== undefined) {
        Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
          if (active(t, generation)) {
            if (result.TAG === /* Ok */ 0) {
              try {
                const workspaces = Mapre_web__Web_codec.workspaces(result._0);
                if (Stdlib__List.exists((function (w) {
                    return Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route));
                  }), workspaces)) {
                  Curry._1(t.emit, {
                    TAG: /* Workspaces */ 1,
                    _0: workspaces
                  });
                  Curry._1(t.emit, {
                    TAG: /* Messages */ 43,
                    _0: /* Access_refreshed */ 6
                  });
                  refresh(t);
                } else {
                  Curry._1(t.failure, {
                    TAG: /* Missing */ 0,
                    _0: "workspace_not_found"
                  });
                }
              }
              catch (raw_exn){
                const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
                  error(t, /* Invalid_response */ 2);
                } else {
                  throw exn;
                }
              }
            } else {
              Curry._1(t.failure, result._0);
            }
          }
          return Promise.resolve();
        });
        return;
      } else {
        return;
      }
    default:
      return Curry._1(t.emit, {
        TAG: /* Messages */ 43,
        _0: action
      });
  }
}

function create(emit, model, failure, subscriptions) {
  return {
    emit,
    model,
    failure,
    subscriptions,
    generation: 0,
    revision: 0,
    controller: new AbortController(),
    loading: false,
    dirty: false
  };
}

export {
  create,
  cancel,
  refresh,
  dispatch,
}
/* Mapre_chat__Chat_projection Not a pure module */
